/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {MarkupBuilder} from '../../interfaces/MarkupBuilder';
import {ExtraChargeType} from '../../interfaces/ExtraChargeType';
import {MarkupPercentageStrategy} from './markup-percentage.strategy';

export class IncreaseByPercentageStrategy extends MarkupPercentageStrategy implements MarkupBuilder {
  apply(price: number, value: number): number {
    return price * (1 + value / 100);
  }

  getType(): ExtraChargeType {
    return ExtraChargeType.INCREASE_PERCENT;
  }

}
